<template>
    <v-card outlined rounded="lg">
        <div class="pa-20 pa-md-24">
            <v-row align-lg="center" class="row--x-large">
                <v-col cols="12" lg="auto" class="mb-10 mb-lg-0">
                    <v-row align="center" class="row--x-large">
                        <v-col cols="auto">
                            <v-simple-checkbox :value="isSelected" @click="select" />
                        </v-col>
                        <v-col cols="auto">
                            <v-row align="center">
                                <v-col cols="auto">
                                    <v-avatar color="grey">
                                        <v-img :src="value?.resume?.profile?.url">
                                            <v-fade-transition>
                                                <v-icon v-show="!value?.resume?.profile?.url" color="white">mdi-account</v-icon>
                                            </v-fade-transition>
                                        </v-img>
                                    </v-avatar>
                                </v-col>
                                <v-col cols="auto">
                                    <v-layout align-center>
                                        <h5 class="page-text--lg font-weight-medium pr-4 pr-lg-0 min-w-lg-80px">
                                            {{ value?.resume?.personalInformation?.name }}
                                        </h5>
                                        <p class="page-text grey-9--text">({{ value?.resume?.personalInformation?.genderText }}, {{ value?.resume?.personalInformation?.age }})</p>
                                    </v-layout>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="" class="recruit-list-item__detail mb-10 mb-lg-0">
                    <ul class="dot-texts">
                        <li v-for="text in cardTextList" :key="text" class="dot-text page-text grey-6--text ellip">· {{ text }}</li>
                    </ul>
                </v-col>
                <v-col cols="12" lg="auto">
                    <v-row class="row--small">
                        <v-col cols="10" lg="auto">
                            <v-row class="row--small">
                                <v-col cols="4" lg="auto">
                                    <v-btn outlined small v-bind="{ color: value?.isCertified ? 'secondary' : 'primary' }" class="w-100 w-lg-100px" @click="showApplicationView(5)">마이스펙인증</v-btn>
                                </v-col>
                                <v-col cols="4" lg="auto">
                                    <v-btn outlined small color="primary" class="w-100 w-lg-100px" @click="showApplicationView(3)">문자발송</v-btn>
                                </v-col>
                                <v-col cols="4" lg="auto">
                                    <v-btn outlined small color="primary" class="w-100 w-lg-100px" @click="showApplicationView(0)">지원자정보</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-spacer class="d-block d-lg-none" />
                        <v-col cols="auto">
                            <v-layout justify-center>
                                <v-btn icon outlined small color="grey-9" @click="showApplicationView(4)">
                                    <v-icon> mdi-checkbox-multiple-blank-outline</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-col>
                        <v-col cols="auto">
                            <like-btn :params="{ _application: value?._id, type: USER_LIKE_TYPES.APPLICATION.value }">
                                <template #activator="{ active, toggle }">
                                    <v-btn icon text small :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="() => !selectable && toggle()">
                                        <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                                    </v-btn>
                                </template>
                            </like-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <application-view v-bind="{ value, recruitment }" @input="(item) => $emit('input', item)" ref="application-view" />
    </v-card>
    <!-- <v-card class="px-24">
        <v-row class="ma-0" align="center">
            <v-col cols="auto">
                <like-btn :params="{ _application: value?._id, type: USER_LIKE_TYPES.APPLICATION.value }">
                    <template #activator="{ active, toggle }">
                        <v-btn icon text :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="() => !selectable && toggle()">
                            <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                        </v-btn>
                    </template>
                </like-btn>
            </v-col>
            <v-col cols="auto">
                <v-row class="ma-0 align-center">
                    <v-col cols="auto">
                        <v-avatar color="grey darken-1" size="30" width="56" height="56">
                            <v-img :src="value?.resume?.profile?.url">
                                <v-fade-transition>
                                    <v-icon v-show="!value?.resume?.profile?.url" color="white">mdi-account</v-icon>
                                </v-fade-transition>
                            </v-img>
                        </v-avatar>
                    </v-col>
                    <v-col cols="auto">
                        <h2 class="font-size-20">{{ value?.resume?.personalInformation?.name }}</h2>
                    </v-col>
                    <v-col cols="auto">
                        <span class="font-size-14 font-weight-regular text--primary"> ({{ value?.resume?.personalInformation?.genderText }}, {{ value?.resume?.personalInformation?.age }}) </span>
                    </v-col>
                    <v-col cols="auto">
                        <like-btn :params="{ _userPerson: value?._applicant, type: USER_LIKE_TYPES.USER_PERSON.value }">
                            <template #activator="{ active, toggle }">
                                <v-btn icon text small :color="active ? 'pink lighten-2' : undefined" @click.stop.prevent.capture="() => !selectable && toggle()">
                                    <v-icon small>{{ active ? "mdi-heart" : "mdi-heart-outline" }}</v-icon>
                                </v-btn>
                            </template>
                        </like-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col>
                <v-row v-for="text in cardTextList" :key="text" no-gutters>
                    <v-col cols="auto"> <v-icon small color="grey lighten-1">mdi-circle-small</v-icon> </v-col> <v-col>{{ text }}</v-col>
                </v-row>
            </v-col>
            <v-col cols="auto" class="pa-0">
                <v-row align="center" class="mx--4">
                    <v-col class="px-4"> <v-btn  outlined v-bind="{ color: value?.isCertified ? 'secondary' : 'primary' }" @click="showApplicationView(5)">마이스펙 인증</v-btn> </v-col>
                    <v-col class="px-4"> <v-btn  outlined color="primary" @click="showApplicationView(3)">문자발송</v-btn> </v-col>
                    <v-col class="px-4"> <v-btn  outlined color="primary" @click="showApplicationView(0)">지원자정보</v-btn> </v-col>
                    <v-col class="px-4">
                        <v-btn outlined fab small icon @click="showApplicationView(4)" class="border-radius-circle">
                            <v-icon> mdi-checkbox-multiple-blank-outline </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <application-view v-bind="{ value, recruitment }" @input="(item) => $emit('input', item)" ref="application-view" />
    </v-card> -->
</template>

<script>
import { EDUCATION_ATTENDING_STATUSES, EDUCATION_INSTITUTION_TYPES, USER_LIKE_TYPES } from "@/assets/variables";

import LikeBtn from "@/components/client/like/like-btn.vue";
import ApplicationView from "../application/application-view.vue";
import api from "@/api";

export default {
    components: {
        LikeBtn,
        ApplicationView,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // application
        selected: { type: Array, default: () => [] },
        recruitment: { type: Object, default: () => ({}) },
    },
    data: () => ({
        USER_LIKE_TYPES,
    }),
    computed: {
        area() {
            let { address1 } = this.value?.resume?.personalInformation?.residence || {};
            return address1?.split?.(" ")?.slice?.(0, 2)?.join?.(" ");
        },
        education() {
            let { institutionType, attendingStatus } = this.value?.resume?.education || {};

            let education = "";
            if (institutionType) education += `${EDUCATION_INSTITUTION_TYPES[institutionType]?.text || ""} `;
            if (attendingStatus) education += `${EDUCATION_ATTENDING_STATUSES[attendingStatus]?.text || ""} `;
            return education.trim();
        },
        cardTextList() {
            return [this.value?.resume?.personalInformation?.phone, this.area, this.education];
        },

        isSelected() {
            return this.selected.some(({ _id }) => _id == this.value?._id);
        },
    },
    methods: {
        showApplicationView(tab = 0) {
            const ref = this.$refs["application-view"];
            ref.$data.tab = tab;
            ref.$data.shows = true;
        },
        select() {
            let selected = [];

            if (this.isSelected) {
                selected = this.selected.filter(({ _id }) => _id != this.value?._id);
            } else {
                selected = [...this.selected, this.value];
            }
            this.$emit("updateSelected", selected);
        },
    },
};
</script>

<style lang="scss" scoped></style>
